import { render } from "./agregarColaborador.vue?vue&type=template&id=6fe513b4&scoped=true"
import script from "./agregarColaborador.vue?vue&type=script&lang=js"
export * from "./agregarColaborador.vue?vue&type=script&lang=js"

import "./agregarColaborador.vue?vue&type=style&index=0&id=6fe513b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe513b4"]])

export default __exports__